




















import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import EsServices from '@/services/es';
import PageMixin from '@/mixins/page-mixin';
import { mixins } from 'vue-class-component';
@Component({
  components: {}
})
export default class RefData extends mixins(PageMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() fieldList!: any[];
  @Prop() code!: string;

  esSrv = new EsServices();

  list: any[] = [];
  @Watch('visible')
  async onVisibleChange() {
    if (!this.syncVisible) return false;
    this.getList();
  }

  async getList() {
    this.loading = true;
    let res: any = await this.esSrv.search(this.code, { page: this.page, limit: this.limit, sort: 'createTime' });
    this.list = res.list.map((v: any) => v.sourceAsMap);
    this.total = res.totalCount;
    this.loading = false;
  }

  get xWidth() {
    return 180 * this.fieldList.length;
  }

  toHump(name: string) {
    // return name.replace(/\_(\w)/g, function(all, letter) {
    //   return letter.toUpperCase();
    // });
    return name;
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
